!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : e.ReactShowMore = t(e.react);
}(this, function (e) {
  "use strict";

  var t = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    },
    n = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }
      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
    r = function (e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    },
    o = function (o) {
      function u(e) {
        t(this, u);
        var n = r(this, (u.__proto__ || Object.getPrototypeOf(u)).call(this, e));
        return n.onMore = function () {
          n.setState(function () {
            return {
              current: n.getNext()
            };
          });
        }, n.getNext = function () {
          return [n.props.replace ? n.state.current[1] + 1 : 0, n.state.current[1] + n.props.by];
        }, n.getItemsChunk = function (e) {
          return function (t) {
            return t.slice(e[0], e[1] + 1);
          };
        }, n.isLastChunk = function (e) {
          var t = n.props.onEnd,
            r = e[1] >= n.props.items.length - 1;
          return r && "function" == typeof t && t(), r;
        }, n.state = {
          current: [0, e.by - 1]
        }, n;
      }
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(u, e.Component), n(u, [{
        key: "render",
        value: function () {
          var e = this.onMore,
            t = this.state.current,
            n = this.props,
            r = n.children,
            o = n.items,
            u = n.by,
            i = this.getItemsChunk(t)(o),
            c = this.isLastChunk(t);
          if ("function" == typeof r) return r({
            current: i,
            by: u,
            all: o,
            onMore: c ? null : e
          });
          throw new Error("`props.children` must be a function");
        }
      }]), u;
    }();
  return o.defaultProps = {
    by: 1,
    onEnd: null,
    replace: !1,
    items: []
  }, o;
});